<template>
  <div class="app">
    <h1>代理记账_记账报税_注册公司_人事社保_名企科技</h1>
    <Header :activeIndex="'1'" />

    <!-- 轮播图 -->
    <div class="carousel">
      <el-carousel class="responsive-carousel" :height="imgHeight">
        <el-carousel-item>
          <img loading="eager" fetchpriority="high" :src="require('../assets/img/img_1.jpg')" alt="名企科技企业财税服务宣传图"
            class="carousel-image" ref="imgHeight" @load="imgLoad">
        </el-carousel-item>
        <el-carousel-item>
          <img loading="eager" fetchpriority="high" :src="require('../assets/img/img_2.jpg')" alt="名企科技工商注册与代理记账服务宣传图"
            class="carousel-image" ref="imgHeight" @load="imgLoad">
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 我们的热门服务 -->
    <section class="popularSer" aria-labelledby="hot-services-title">
      <h2 id="hot-services-title" class="minePopular">热门服务🔥</h2>
      <div class="serviceContainer">
        <article class="service1" @click="pathgongshang" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">注&nbsp;册<br>公&nbsp;司</h3>
          <meta itemprop="description" content="北京公司注册、营业执照代办、工商注册服务">
        </article>
        <article class="service2" @click="pathJizhang" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">代&nbsp;理<br>记&nbsp;账</h3>
          <meta itemprop="description" content="专业代理记账、报税服务，持有财政部许可证">
        </article>
        <article class="service2" @click="pathgongshang" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">工&nbsp;商<br>变&nbsp;更</h3>
          <meta itemprop="description" content="公司变更、股权变更、法人变更、地址变更">
        </article>
        <article class="service2" @click="pathrenshi" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">人&nbsp;事<br>社&nbsp;保</h3>
          <meta itemprop="description" content="社保托管、公积金代办、人事代理服务">
        </article>
        <article class="service2" @click="pathgongshang" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">解&nbsp;除<br>异&nbsp;常</h3>
          <meta itemprop="description" content="工商异常解除、税务异常处理">
        </article>
      </div>
      <div class="serviceContainer">
        <article class="service1" @click="pathgongshang" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">清&nbsp;算<br>注&nbsp;销</h3>
          <meta itemprop="description" content="公司注销、税务清算、工商注销">
        </article>
        <article class="service2" @click="pathzhichan" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">知&nbsp;识<br>产&nbsp;权</h3>
          <meta itemprop="description" content="商标注册、软著申请、高新企业申报">
        </article>
        <article class="service2" @click="pathxuke" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">资&nbsp;质<br>许&nbsp;可</h3>
          <meta itemprop="description" content="各类经营许可证代办、资质申请">
        </article>
        <article class="service2" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">招&nbsp;聘<br>制&nbsp;度</h3>
          <meta itemprop="description" content="企业招聘制度设计">
        </article>
        <article class="service2" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">薪&nbsp;酬<br>制&nbsp;度</h3>
          <meta itemprop="description" content="企业薪酬体系设计">
        </article>
      </div>
      <div class="serviceContainer" v-if="!isMobile">
        <article class="service1" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">管&nbsp;理<br>制&nbsp;度</h3>
          <meta itemprop="description" content="企业管理制度设计">
        </article>
        <article class="service2" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">财&nbsp;务<br>制&nbsp;度</h3>
          <meta itemprop="description" content="企业财务制度设计">
        </article>
        <article class="service2" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">组&nbsp;织&nbsp;架&nbsp;构<br>优&nbsp;化</h3>
          <meta itemprop="description" content="企业组织架构优化设计">
        </article>
        <article class="service2" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">运&nbsp;营&nbsp;流&nbsp;程<br>优&nbsp;化</h3>
          <meta itemprop="description" content="企业运营流程优化">
        </article>
        <article class="service2" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">驻&nbsp;场<br>诊&nbsp;断</h3>
          <meta itemprop="description" content="企业驻场诊断服务">
        </article>
      </div>
      <div class="serviceContainer" v-else>
        <article class="service1" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">管&nbsp;理<br>制&nbsp;度</h3>
          <meta itemprop="description" content="企业管理制度设计">
        </article>
        <article class="service2" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">财&nbsp;务<br>制&nbsp;度</h3>
          <meta itemprop="description" content="企业财务制度设计">
        </article>
        <article class="service3" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">组织架构<br>优&nbsp;化</h3>
          <meta itemprop="description" content="企业组织架构优化设计">
        </article>
        <article class="service3" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">运营流程<br>优&nbsp;化</h3>
          <meta itemprop="description" content="企业运营流程优化">
        </article>
        <article class="service2" @click="pathzhidu" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">驻&nbsp;场<br>诊&nbsp;断</h3>
          <meta itemprop="description" content="企业驻场诊断服务">
        </article>
      </div>


      <div class="serviceContainer" v-if="!isMobile">
        <article class="service1" @click="pathxinxi" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">工&nbsp;作&nbsp;流<br>&nbsp;管&nbsp;理&nbsp;系&nbsp;统</h3>
          <meta itemprop="description" content="工作流管理系统开发">
        </article>
        <article class="service2" @click="pathxinxi" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">C&nbsp;R&nbsp;M<br>&nbsp;管&nbsp;理&nbsp;系&nbsp;统</h3>
          <meta itemprop="description" content="CRM客户关系管理系统开发">
        </article>
        <article class="service2" @click="pathxinxi" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">企&nbsp;业&nbsp;<br>信&nbsp;息&nbsp;库</h3>
          <meta itemprop="description" content="企业信息库系统开发">
        </article>
        <article class="service2" @click="pathxinxi" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">出&nbsp;版<br>大&nbsp;师</h3>
          <meta itemprop="description" content="出版管理系统开发">
        </article>
        <article class="service2" @click="pathxinxi" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">定&nbsp;制<br>开&nbsp;发</h3>
          <meta itemprop="description" content="软件定制开发服务">
        </article>
      </div>
      <div class="serviceContainer" v-else>
        <article class="service4" @click="pathxinxi" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">工作流<br>管理系统</h3>
          <meta itemprop="description" content="工作流管理系统开发">
        </article>
        <article class="service3" @click="pathxinxi" style="flex-direction: column;" itemscope
          itemtype="https://schema.org/Service">
          <h3 itemprop="name" style="line-height:20px;">CRM<br>管理系统</h3>
          <meta itemprop="description" content="CRM客户关系管理系统开发">
        </article>
        <article class="service2" @click="pathxinxi" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">企业<br>信息库</h3>
          <meta itemprop="description" content="企业信息库系统开发">
        </article>
        <article class="service2" @click="pathxinxi" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">出&nbsp;版<br>大&nbsp;师</h3>
          <meta itemprop="description" content="出版管理系统开发">
        </article>
        <article class="service2" @click="pathxinxi" itemscope itemtype="https://schema.org/Service">
          <h3 itemprop="name">定&nbsp;制<br>开&nbsp;发</h3>
          <meta itemprop="description" content="软件定制开发服务">
        </article>
      </div>
    </section>

    <!-- 我们的服务优势 -->
    <section class="popularSer">
      <span class="minePopular">我们的服务优势👍</span>
      <div class="fuwuyoushi">
        <div class="box">
          <div class="ziyuanheight">
            <div class="goodtitle">资源&nbsp;更丰富</div>
          </div>
          <ul class="goodtext">
            <li>地址、工商、税务</li>
            <li>优质解决方案</li>
          </ul>
        </div>
        <div class="box">
          <div class="ziyuanheight">
            <div class="goodtitle">服务&nbsp;更专业</div>
          </div>
          <ul class="goodtext">
            <li>会计、人事、客服</li>
            <li>团队服务有保障</li>
          </ul>
        </div>
      </div>
      <div style="display:flex;justify-content: center;text-align: left;">
        <div class="box">
          <div class="ziyuanheight">
            <div class="goodtitle">经验&nbsp;更全面</div>
          </div>
          <ul class="goodtext">
            <li>上千家企业案例</li>
            <li>解决问题轻车熟路</li>
          </ul>
        </div>
        <div class="box">
          <div class="ziyuanheight">
            <div class="goodtitle">老板&nbsp;更放心</div>
          </div>
          <ul class="goodtext">
            <li>管理规范&nbsp;流程明晰</li>
            <li>认真做事&nbsp;诚信负责</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 腰线 -->
    <div v-if="!isMobile">
      <div class="yaoxianda">
        <div>
          <div class="biaoti">名企科技</div>
          <div class="quanfangwei">全方位的<span style="font-weight:600;">工商代办</span>,真正的<span style="font-weight:600;">服务
            </span> <span class="fangxin">"放心"</span></div>
          <div style="display:flex;margin-top:5px;">
            <div>
              <div class="duigou"><span style="color:red;">√ 专业</span>团队服务，更专业</div>
              <div class="duigou1"><span style="color:red;">√ 高效</span>经验丰富，更高效</div>
            </div>
            <div class="duichen">
              <div class="duigou"><span style="color:red;">√ 规范</span>管理，工作质量有保障</div>
              <div class="duigou1"><span style="color:red;">√ 放心</span>注册、开票、社保全托管</div>
            </div>
          </div>
        </div>
        <div>
          <div class="rexian">服务热线：<span class="shoujihao">1391 0303 798</span></div>
        </div>
        <div class="hongdise">
          <div>名企科技</div>
          <div>工商注册</div>
          <div>代理记账</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="yaoxianda">
        <div>
          <div class="biaoti">财务服务，就找名企科技！</div>
          <div class="quanfangwei">全方位的<span style="font-weight:600;">工商代办</span>,真正的<span style="font-weight:600;">服务
            </span> <span class="fangxin">"放心"！</span></div>
          <div style="display:flex;margin-top:4px;">
            <div>
              <div class="duigou"><span style="color:red;font-weight:700;">√ 专业</span>团队服务，更专业</div>
              <div class="duigou1"><span style="color:red;font-weight:700;">√ 高效</span>经验丰富，更高效</div>
            </div>
            <div class="duichen">
              <div class="duigou"><span style="color:red;font-weight:700;">√ 规范</span>管理，质量有保障</div>
              <div class="duigou1"><span style="color:red;font-weight:700;">√ 放心</span>托管，安全又可靠</div>
            </div>
          </div>
        </div>
        <div class="hongdise">
          <div>名企科技</div>
          <div>工商注册</div>
          <div>代理记账</div>
          <div>服务热线:</div>
          <div>1391 0303 798</div>
        </div>
      </div>
    </div>

    <!-- 成功案例 -->
    <section class="popularSer">
      <span class="minePopular">客户案例🏆</span>
      <div>
        <div v-if="!isMobile" class="carouselcard">
          <div class="succ">
            <div class="success1">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_1.jpg')"
                alt="注册公司 代办营业执照">
              <div class="text4">注册公司 代办营业执照</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_4.jpg')" alt="代理记账、报税">
              <div class="text4">代理记账、报税</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_3.jpg')" alt="工商变更 股权转让">
              <div class="text4">工商变更 股权转让</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_5.jpg')" alt="刻章服务">
              <div class="text4">刻章服务</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_7.jpg')" alt="公司清算、注销">
              <div class="text4">公司清算、注销</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_2.jpg')" alt="注册商标">
              <div class="text4">注册商标</div>
            </div>
          </div>

          <div class="succ1">
            <div class="success1">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_9.jpg')"
                alt="增值电信业务许可证 ICP、EDI">
              <div class="text2">增值电信业务许可证 ICP、EDI</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_8.jpg')" alt="食品经营许可证">
              <div class="text3">食品经营许可证</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_10.jpg')" alt="出版物经营许可证">
              <div class="text3">出版物经营许可证</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_11.jpg')"
                alt="认证体系 质量、环境、职业健康">
              <div class="text3">三体系认证、质量认证</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_12.jpg')" alt="软件著作权证书">
              <div class="text3">软件著作权证书</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_6.jpg')" alt="进出口许可证">
              <div class="text3">进出口许可证</div>
            </div>
          </div>
        </div>
        <div v-else class="carouselcard">
          <div class="succ">
            <div class="success1">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_1.jpg')"
                alt="注册公司 代办营业执照">
              <div class="text4">注册公司<br>代办营业执照</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_4.jpg')" alt="代理记账、报税">
              <div class="text4">代理记账、报税</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_3.jpg')" alt="工商变更 股权转让">
              <div class="text4">工商变更<br>股权转让</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_5.jpg')" alt="刻章服务">
              <div class="text4">刻章服务</div>
            </div>
          </div>

          <div class="succ1">
            <div class="success1">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_7.jpg')" alt="公司清算、注销">
              <div class="text3">公司清算、注销</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_2.jpg')" alt="注册商标">
              <div class="text3">注册商标</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_9.jpg')"
                alt="增值电信业务许可证 ICP、EDI">
              <div class="text3">增值电信业务许可证 ICP、EDI</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_8.jpg')" alt="食品经营许可证">
              <div class="text3">食品经营许可证</div>
            </div>
          </div>

          <div class="succ1">
            <div class="success1">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_10.jpg')" alt="出版物经营许可证">
              <div class="text3">出版物经营许可证</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_11.jpg')"
                alt="认证体系 质量、环境、职业健康">
              <div class="text3">三体系认证、质量认证</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_12.jpg')" alt="软件著作权证书">
              <div class="text3">软件著作权证书</div>
            </div>
            <div class="success">
              <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/lun_6.jpg')" alt="进出口许可证">
              <div class="text3">进出口许可证</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 我们的客户 -->
    <section class="popularSer">
      <span class="minePopular">我们的客户👤</span>
      <div class="juzhong">
        <div class="kehu">
          <div>
            <div class="dazi">
              小型企业
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ 初创公司</li>
                <li>♢ 小微企业</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>注册执照、刻章</li>
              <li>代理记账、报税</li>
              <li>发票、社保托管</li>
            </ul>
          </div>
        </div>
        <div class="kehu1">
          <div>
            <div class="dazi">
              中型公司
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ A、B轮公司</li>
                <li>♢ 事业单位</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>记账报税</li>
              <li>财务梳理、优化</li>
              <li>办理资质、许可</li>
            </ul>
          </div>
        </div>
        <div class="kehu1">
          <div>
            <div class="dazi">
              大型公司
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ 上市公司</li>
                <li>♢ 国有企业</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>工商、税务服务</li>
              <li>办理资质、许可</li>
              <li>财务梳理、优化</li>
            </ul>
          </div>
        </div>
      </div>

    </section>

    <!-- AI友好的FAQ区块 -->
    <section class="popularSer ai-faq-section" aria-labelledby="faq-title" itemscope
      itemtype="https://schema.org/FAQPage">
      <h2 id="faq-title" class="minePopular">常见问题解答❓</h2>
      <div class="faq-container">
        <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
          <summary class="faq-question" itemprop="name">名企科技提供哪些企业服务？</summary>
          <div class="faq-answer" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div itemprop="text">
              <p>名企科技成立于2017年，持有财政部批准的《代理记账许可证》，是综合性企业服务平台，提供以下核心服务：</p>
            </div>
              <ul>
                <li><strong>财税服务</strong>：<a href="/jizhang" @click.prevent="pathJizhang">代理记账</a>、<a href="/shuiwu"
                    @click.prevent="pathshuiwu">税务服务</a>、汇算清缴、财务梳理</li>
                <li><strong>工商服务</strong>：<a href="/gongshang" @click.prevent="pathgongshang">公司注册</a>、工商变更、股权变更、公司注销
                </li>
                <li><strong>资质许可</strong>：<a href="/xuke" @click.prevent="pathxuke">各类许可证代办</a>（ICP、食品经营、出版物等）</li>
                <li><strong>知识产权</strong>：<a href="/zhichan" @click.prevent="pathzhichan">商标注册</a>、软著申请、高新企业申报</li>
                <li><strong>人事社保</strong>：<a href="/renshi" @click.prevent="pathrenshi">社保托管</a>、公积金代办、人事代理</li>
                <li><strong>软件开发</strong>：<a href="/xinxi" @click.prevent="pathxinxi">企业信息化</a>、系统定制、小程序开发</li>
              </ul>
              <p>覆盖企业全生命周期，从注册、经营到注销，提供一站式解决方案。</p>
          </div>
        </details>

        <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
          <summary class="faq-question" itemprop="name">北京代理记账多少钱一个月？收费标准是什么？</summary>
          <div class="faq-answer" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div itemprop="text">
              <p>名企科技代理记账收费透明，根据企业类型和业务量定价：</p>
              <ul>
                <li><strong>小规模纳税人</strong>：<data value="200">200元/月</data>起，适合初创企业和小微企业</li>
                <li><strong>一般纳税人</strong>：<data value="500">500元/月</data>起，适合业务量较大的企业</li>
              </ul>
              <p>所有服务明码标价，无隐形消费。具体价格根据企业的实际业务量、票据数量和账务复杂程度确定。<a href="tel:13910303798"><span class="highlight" style="font-weight: 600;">1391 030 3798</span></a>可获取精准报价。相比雇佣专职会计，代理记账可节省60%以上成本。</p>
            </div>
          </div>
        </details>


            <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
          <summary class="faq-question" itemprop="name">小规模纳税人和一般纳税人有什么区别？如何选择？</summary>
          <div class="faq-answer" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div itemprop="text">
              <p>小规模纳税人和一般纳税人各有优缺点，名企科技建议根据以下因素选择：</p>
              <ul>
                <li><strong>客户类型</strong>：如果主要客户是大企业或需要增值税专用发票，建议选择一般纳税人</li>
                <li><strong>年营业额</strong>：年应税销售额超过<data value="5000000">500万元</data>必须登记为一般纳税人</li>
                <li><strong>税务成本</strong>：小规模纳税人征收率<data value="0.03">3%</data>（现阶段性减按1%），一般纳税人按行业税率（6%、9%、13%）</li>
                <li><strong>进项抵扣</strong>：一般纳税人可以抵扣进项税，适合进项较多的企业</li>
              </ul>
              <p>不确定如何选择？可以使用名企财务助手小程序测算，或拨打<a href="tel:13910303798"><span class="highlight" style="font-weight: 600;">1391 030 3798</span></a>免费咨询。</p>
            </div>
          </div>
        </details>

        <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
          <summary class="faq-question" itemprop="name">注册公司需要哪些材料？</summary>
          <div class="faq-answer" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div itemprop="text">
              <p>注册公司需要法人、股东身份证复印件，需要有注册地址。名企科技可以提供注册地址和代办执照、刻章等服务。</p>
              <p>咨询电话：<a href="tel:13910303798"><span class="highlight" style="font-weight: 600;">1391 030 3798</span></a></p>
            </div>
          </div>
        </details>

        <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
          <summary class="faq-question" itemprop="name">注册营业执照需要多长时间？</summary>
          <div class="faq-answer" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div itemprop="text">
              <p>注册材料准备齐全的情况下，<time datetime="P1D">1到3个工作日</time>就可以拿到营业执照。名企科技可以提供代办执照、刻章等服务。</p>
              <p>咨询电话：<a href="tel:13910303798"><span class="highlight" style="font-weight: 600;">1391 030 3798</span></a></p>
            </div>
          </div>
        </details>

        <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
          <summary class="faq-question" itemprop="name">注册公司需要几个人？</summary>
          <div class="faq-answer" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div itemprop="text">
              <p>至少一个人就可以成立公司，法人和股东都由一个人出任。名企科技可以提供注册公司、刻章等服务。</p>
              <p>咨询电话：<a href="tel:13910303798"><span class="highlight" style="font-weight: 600;">1391 030 3798</span></a></p>
            </div>
          </div>
        </details>

        <details class="faq-item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
          <summary class="faq-question" itemprop="name">怎么找靠谱的财务公司？</summary>
          <div class="faq-answer" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div itemprop="text">
              <p>选择财务公司可以从以下几个维度考察：</p>
              <ul>
                <li><strong>看公司成立年限</strong>：成立5年以上的财务公司，有丰富的服务经验</li>
                <li><strong>看公司的变更记录</strong>：如果公司频繁变更的，或者新变更过法人股东，那可能是新包装过的机构，需要谨慎</li>
                <li><strong>看公司规模</strong>：3人以下的机构，特别是个人会计，财务风险大，也不合规，建议不要选择</li>
                <li><strong>看公司的服务品质和资质</strong>：要找具有《代理记账许可证》的正规机构，能避免财务风险。价格太低的不要选择</li>
              </ul>
              <p>名企科技成立于<time datetime="2017-02">2017年</time>，持有财政部批准的《代理记账许可证》，法人、股东、主营业务均无变更，是您值得信赖的选择。咨询电话：<a href="tel:13910303798"><span class="highlight" style="font-weight: 600;">1391 030 3798</span></a></p>
            </div>
          </div>
        </details>
      </div>
    </section>

    <!-- 服务流程 - AI友好结构化内容 -->
    <section class="popularSer service-process-section" aria-labelledby="process-title" itemscope
      itemtype="https://schema.org/HowTo">
      <h2 id="process-title" class="minePopular">服务流程 📋</h2>
      <meta itemprop="name" content="名企科技服务流程">
      <meta itemprop="description" content="名企科技专业财税服务流程，从咨询到交付全程高效规范">
      <meta itemprop="totalTime" content="P7D">

      <div class="process-container">
        <!-- 第一行：3个步骤 -->
        <div class="process-row row-3">
          <div class="process-step" itemprop="step" itemscope itemtype="https://schema.org/HowToStep">
            <div class="step-number">1</div>
            <div class="step-content">
              <h3 itemprop="name">在线咨询</h3>
              <p itemprop="text">拨打&nbsp;<a href="tel:13910303798"><span class="highlight">1391 030 3798</span> </a> &nbsp;或微信咨询，专业顾问了解您的需求</p>
              <meta itemprop="url" content="https://mingqicaiwu.com/contact">
            </div>
          </div>

          <div class="process-arrow">→</div>

          <div class="process-step" itemprop="step" itemscope itemtype="https://schema.org/HowToStep">
            <div class="step-number">2</div>
            <div class="step-content">
              <h3 itemprop="name">需求确认</h3>
              <p itemprop="text">顾问根据您的具体情况，<span class="highlight">制定个性化服务方案</span></p>
            </div>
          </div>

          <div class="process-arrow">→</div>

          <div class="process-step" itemprop="step" itemscope itemtype="https://schema.org/HowToStep">
            <div class="step-number">3</div>
            <div class="step-content">
              <h3 itemprop="name">签订合同</h3>
              <p itemprop="text"><span class="highlight">明确服务内容、费用标准</span>，签署正式服务协议</p>
            </div>
          </div>
        </div>

        <!-- 连接箭头 -->
        <div class="row-connector">
          <div class="connector-line"></div>
          <div class="connector-arrow">↓</div>
        </div>

        <!-- 第二行：2个步骤 -->
        <div class="process-row row-2">
          <div class="process-step" itemprop="step" itemscope itemtype="https://schema.org/HowToStep">
            <div class="step-number">4</div>
            <div class="step-content">
              <h3 itemprop="name">材料准备</h3>
              <p itemprop="text">顾问指导您准备所需材料，<span class="highlight">专业代办</span></p>
            </div>
          </div>

          <div class="process-arrow">→</div>

          <div class="process-step" itemprop="step" itemscope itemtype="https://schema.org/HowToStep">
            <div class="step-number">5</div>
            <div class="step-content">
              <h3 itemprop="name">办理完成</h3>
              <p itemprop="text">专业团队快速办理，<time datetime="P7D"><span class="highlight">专业、高效、规范</span></time>完成交付</p>
            </div>
          </div>
        </div>
      </div>
      </section>
    <!-- 服务优势对比 -->
    <div class="service-comparison" itemscope itemtype="https://schema.org/Table">
      <h3 style="font-size:35px;">名企科技 <span class="vs-text">vs</span> 普通财务机构 <span class="vs-text">vs</span> 个人会计 <span class="vs-text">服务对比</span></h3>
      <!-- PC端表格 -->
      <table class="comparison-table" v-if="!isMobile">
        <thead>
          <tr>
            <th class="col-item" style="text-align: center;font-size:20px;">对比项</th>
            <th class="highlight-col col-mq" style="text-align: center;font-size:20px;">名企科技</th>
            <th class="col-other" style="text-align: center;font-size:20px;">普通财务机构</th>
            <th class="col-other" style="text-align: center;font-size:20px;">个人会计</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="col-item"><strong><i>1.</i><div>人员配置</div></strong></td>
            <td class="highlight-col col-mq">配备会计、人事、专职客服完整团队，岗位分工清晰，可提供一站式配套服务</td>
            <td class="col-other">多为单人或少量会计运营，岗位未细分，配套增值服务较少</td>
            <td class="col-other">不具备代理记账机构资质，无专职客服及后勤配套支持</td>
          </tr>
          <tr>
            <td class="col-item"><strong><i>2.</i><div>办理时间</div></strong></td>
            <td class="highlight-col col-mq">标准化业务流程，团队协作处理，业务办理时效稳定可控</td>
            <td class="col-other">多由单人统筹全部业务，业务高峰期办理周期可能延长</td>
            <td class="col-other">时间由个人自主安排，接单量波动会影响办理时效稳定性</td>
          </tr>
          <tr>
            <td class="col-item"><strong><i>3.</i><div>专业程度</div></strong></td>
            <td class="highlight-col col-mq">2017年起深耕财税行业，长期服务各类中小微企业，实操经验充足，配套行业资源完善</td>
            <td class="col-other">业务重心偏市场拓展，服务团队配置规模不一</td>
            <td class="col-other">服务客户体量偏小，可调动的行业配套资源较少</td>
          </tr>
          <tr>
            <td class="col-item"><strong><i>4.</i><div>服务能力</div></strong></td>
            <td class="highlight-col col-mq">注册公司、记账报税、变更、注销、申请许可、资质代办、社保公积金托管、提供注册地址、软件开发，提供企业财务、人事、软件一站式服务</td>
            <td class="col-other">可调动资源相对有限，服务覆盖范围较窄</td>
            <td class="col-other">可调动资源较少，服务覆盖范围有限</td>
          </tr>
          <tr>
            <td class="col-item"><strong><i>5.</i><div>质量保障</div></strong></td>
            <td class="highlight-col col-mq">搭建内部标准化服务复核管控体系，全流程跟进，配套完善售后对接机制</td>
            <td class="col-other">多侧重业务签约环节，内部服务复核机制相对简化</td>
            <td class="col-other">无标准化内部服务流程，出现账务问题无企业主体兜底售后</td>
          </tr>
          <tr>
            <td class="col-item"><strong><i>6.</i><div>安全保障</div></strong></td>
            <td class="highlight-col col-mq">持有正规《代理记账许可证》，北京核心区域固定实体办公，全业务流程把关</td>
            <td class="col-other">部分机构定价较低，合作前建议核验代理记账相关资质</td>
            <td class="col-other">不具备办理《代理记账许可证》的主体资格，不符合财税代理行业监管资质要求</td>
          </tr>
          <tr>
            <td class="col-item"><strong><i>7.</i><div>服务费用</div></strong></td>
            <td class="highlight-col col-mq">按业务复杂程度分级定价，收费标准统一；注册+刻章套餐900元，可提供免费注册地址资源；代理记账明码标价，收费明细清晰透明</td>
            <td class="col-other">无统一公开收费标准，建议合作前逐项确认全部服务内容及收费明细</td>
            <td class="col-other">无统一公开收费标准，缺乏系统化价格体系</td>
          </tr>
          <tr>
            <td class="col-item"><strong><i>8.</i><div>服务理念</div></strong></td>
            <td class="highlight-col col-mq">坚持专业、高效、规范化一站式企业财税服务定位</td>
            <td class="col-other">经营重心偏业务拓展</td>
            <td class="col-other">无统一标准化服务流程约束</td>
          </tr>
          <tr>
            <td class="col-item"><strong><i>9.</i><div>公司运营时间</div></strong></td>
            <td class="highlight-col col-mq">2017年成立，长期专注企业财税服务赛道，工商登记信息中法人、股东、主营业务均无变更</td>
            <td class="col-other">部分机构成立周期较短，存在法人、股权、经营范围多次变更登记情况</td>
            <td class="col-other">不属于企业经营主体，无经营年限参考维度</td>
          </tr>
        </tbody>
      </table>
      <!-- 移动端卡片布局 -->
      <div class="comparison-cards" v-else>
        <div class="comparison-card" v-for="(row, index) in comparisonData" :key="index">
          <div class="card-title">{{ row.item }}</div>
          <div class="card-columns">
            <div class="card-col card-col-mq">
              <div class="card-label">名企科技</div>
              <div class="card-value mq">{{ row.mingqi }}</div>
            </div>
            <div class="card-col">
              <div class="card-label">普通财务机构</div>
              <div class="card-value">{{ row.normal }}</div>
            </div>
            <div class="card-col">
              <div class="card-label">个人会计</div>
              <div class="card-value">{{ row.personal }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </section>

    <!-- 腰线 -->
    <div class="yaoxianda1">
      <div class="hongdise1">
        <div>名企科技</div>
        <div>工商注册</div>
        <div>代理记账</div>
      </div>
      <div>
        <div class="quanfangwei2">服务热线：</div>
        <div class="quanfangwei1">1391 0303 798</div>
      </div>
      <div class="kuandu">
        <div class="biaoti1">名企财务-更专业，</div>
        <div class="biaoti2">更高效，更规范！</div>
      </div>
    </div>

    <!-- 客户怎么说 -->
    <section class="popularSer">
      <span class="minePopular">客户的好评🥇</span>
      <div v-if="!isMobile" style="margin-top:6px;">
        <div class="succ">
          <div class="success1">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_1.jpg')" alt="表扬：热情周到👍">
            <div class="text">好评：热情周到👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_2.jpg')" alt="表扬：真诚服务👍">
            <div class="text">好评：真诚服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_3.jpg')" alt="表扬：爱岗敬业👍">
            <div class="text">好评：爱岗敬业👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_4.jpg')" alt="表扬：信守承诺👍">
            <div class="text">好评：信守承诺👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_5.jpg')" alt="表扬：办事高效👍">
            <div class="text">好评：办事高效👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_6.jpg')" alt="表扬：追求卓越👍">
            <div class="text">好评：追求卓越👍</div>
          </div>
        </div>

        <div class="succ1">
          <div class="success1">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_7.jpg')" alt="表扬：优质服务👍">
            <div class="text1">好评：优质服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_8.jpg')" alt="表扬：服务高效👍">
            <div class="text1">好评：服务高效👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_9.jpg')" alt="表扬：技高心细👍">
            <div class="text1">好评：技高心细👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_10.jpg')" alt="表扬：真情服务👍">
            <div class="text1">好评：真情服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_11.jpg')" alt="表扬：专业高效👍">
            <div class="text1">好评：专业高效👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_12.jpg')" alt="表扬：热心真诚👍">
            <div class="text1">好评：热心真诚👍</div>
          </div>
        </div>
      </div>
      <div v-else style="margin-top:5px;">
        <div class="succ">
          <div class="success1">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_1.jpg')" alt="表扬：热情周到👍">
            <div class="text">热情周到👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_2.jpg')" alt="表扬：真诚服务👍">
            <div class="text">真诚服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_3.jpg')" alt="表扬：爱岗敬业👍">
            <div class="text">爱岗敬业👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_4.jpg')" alt="表扬：信守承诺👍">
            <div class="text">信守承诺👍</div>
          </div>
        </div>

        <div class="succ1">
          <div class="success1">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_5.jpg')" alt="表扬：办事高效👍">
            <div class="text">办事高效👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_6.jpg')" alt="表扬：追求卓越👍">
            <div class="text">追求卓越👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_7.jpg')" alt="表扬：优质服务👍">
            <div class="text1">优质服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_8.jpg')" alt="表扬：服务高效👍">
            <div class="text1">服务高效👍</div>
          </div>
        </div>

        <div class="succ1">
          <div class="success1">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_9.jpg')" alt="表扬：技高心细👍">
            <div class="text1">技高心细👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_10.jpg')" alt="表扬：真情服务👍">
            <div class="text1">真情服务👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_11.jpg')" alt="表扬：专业高效👍">
            <div class="text1">专业高效👍</div>
          </div>
          <div class="success">
            <img loading="lazy" class="carousel-imagecard" :src="require('../assets/img/qi_12.jpg')" alt="表扬：热心真诚👍">
            <div class="text1">热心真诚👍</div>
          </div>
        </div>
      </div>

      <!-- 企业权威性引用 -->
      <blockquote cite="https://mingqicaiwu.com" class="company-quote">
        <p>"名企科技<time
            datetime="2017">自2017年</time>成立以来，始终秉承<strong>'专业、高效、规范、诚信'</strong>的服务理念，已为<strong>上千家企业</strong>提供财税服务。作为持有财政部批准的《代理记账许可证》的正规机构，我们深知企业财税管理的重要性。无论是初创企业的<a
            href="/gongshang" @click.prevent="pathgongshang">公司注册</a>，还是成熟企业的<a href="/shuiwu"
            @click.prevent="pathshuiwu">税务筹划</a>，名企科技都能提供专业可靠的一站式解决方案。选择名企科技，就是选择放心！"</p>
        <footer>— <cite>名企科技 CEO</cite></footer>
      </blockquote>
    </section>

    <!-- 新闻 -->
    <section class="popularSer">
      <span class="minePopular">老板学院<i class="el-icon-key"></i></span>
      <div class="newInfo">
        <div class="index_ans01">
          <div class="index_ans02">
            <div class="gengduo" @click="pathxueyuan">更多>>>
            </div>
            <table class="tableCSS">
              <tbody>
                <tr v-for="(news, index) in newsList" :key="news.id">
                  <td class="tdCSS1">{{ news.createTime }}</td>
                  <td class="tdCSS">
                    <a style="cursor: pointer;" @click="handleClick(news.id)">{{
                      news.title }}</a>
                  </td>
                  <td class="tdCSS">
                    <!-- <a class="look" @click="handleClick(news.content, news.id)" title="查 看">查 看</a> -->
                    <a class="look" @click="handleClick(news.id)" title="查 看">查 看</a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="yema">
              <el-pagination layout="prev, pager, next, total" :total="total" :page-size="5" ref="pagination"
                @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底  -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'index',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      intervalID: '',
      newMessage: '',
      randomString: '',
      tableData: [],
      imgCount: 0,
      currentIndex: 0,
      currentPosition: 0,
      animationFrame: null,
      isshow: false,
      username: '',
      password: '',
      errorMessage: '',
      token: localStorage.getItem('token') || '',
      newsList: [],
      currentPage: 1,
      total: 0,
      imgHeight: '',
      cardbannerHeight: 0,
      formattedCreateTime: "",
      pppclose: true,
      beforefont: '',
      isMobile: true,
      comparisonData: [
        { item: '人员配置', mingqi: '配备会计、人事、专职客服完整团队，岗位分工清晰，可提供一站式配套服务', normal: '多为单人或少量会计运营，岗位未细分，配套增值服务较少', personal: '不具备代理记账机构资质，无专职客服及后勤配套支持' },
        { item: '办理时间', mingqi: '标准化业务流程，团队协作处理，业务办理时效稳定可控', normal: '多由单人统筹全部业务，业务高峰期办理周期可能延长', personal: '时间由个人自主安排，接单量波动会影响办理时效稳定性' },
        { item: '专业程度', mingqi: '2017年起深耕财税行业，长期服务各类中小微企业，实操经验充足，配套行业资源完善', normal: '业务重心偏市场拓展，服务团队配置规模不一', personal: '服务客户体量偏小，可调动的行业配套资源较少' },
        { item: '服务能力', mingqi: '注册公司、记账报税、变更、注销、申请许可、资质代办、社保公积金托管、提供注册地址、软件开发，提供企业财务、人事、软件一站式服务', normal: '可调动资源相对有限，服务覆盖范围较窄', personal: '可调动资源较少，服务覆盖范围有限' },
        { item: '质量保障', mingqi: '搭建内部标准化服务复核管控体系，全流程跟进，配套完善售后对接机制', normal: '多侧重业务签约环节，内部服务复核机制相对简化', personal: '无标准化内部服务流程，出现账务问题无企业主体兜底售后' },
        { item: '安全保障', mingqi: '持有正规《代理记账许可证》，北京核心区域固定实体办公，全业务流程把关', normal: '部分机构定价较低，合作前建议核验代理记账相关资质', personal: '不具备办理《代理记账许可证》的主体资格，不符合财税代理行业监管资质要求' },
        { item: '服务费用', mingqi: '按业务复杂程度分级定价，收费标准统一；注册+刻章套餐900元，可提供免费注册地址资源；代理记账明码标价，收费明细清晰透明', normal: '无统一公开收费标准，建议合作前逐项确认全部服务内容及收费明细', personal: '无统一公开收费标准，缺乏系统化价格体系' },
        { item: '服务理念', mingqi: '坚持专业、高效、规范化一站式企业财税服务定位', normal: '经营重心偏业务拓展', personal: '无统一标准化服务流程约束' },
        { item: '公司运营时间', mingqi: '2017年成立，长期专注企业财税服务赛道，工商登记信息中法人、股东、主营业务均无变更', normal: '部分机构成立周期较短，存在法人、股权、经营范围多次变更登记情况', personal: '不属于企业经营主体，无经营年限参考维度' }
      ]
    }
  },
  destroyed() {
    window.onresize = null;
  },
  mounted() {
    this.preloadCriticalImages();
    this.addServiceSchema();
    this.fetchNews();
    this.$root.showData.showData = false;
    this.imgLoad()
    window.onresize = () => {
      this.imgLoad()
    }
    this.cardbannerHeight = window.innerWidth <= 768 ? '180' : '390'
    window.scrollTo(0, 0);
    this.checkScreenSize(); // 初始化时检查屏幕大小
    window.addEventListener('resize', this.checkScreenSize); // 监听窗口大小变化
  },
  beforeDestroy() {
    // 移除全局点击事件监听
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    preloadCriticalImages() {
      const criticalImages = [
        require('../assets/img/img_1.jpg'),
        require('../assets/img/img_2.jpg')
      ];

      criticalImages.forEach((href, index) => {
        const preloadId = `critical-home-image-${index + 1}`;
        if (document.getElementById(preloadId)) {
          return;
        }

        const link = document.createElement('link');
        link.id = preloadId;
        link.rel = 'preload';
        link.as = 'image';
        link.href = href;
        link.setAttribute('fetchpriority', 'high');
        document.head.appendChild(link);
      });
    },
    addServiceSchema() {
      const schemaId = 'service-schema';

      // 避免重复插入
      if (document.getElementById(schemaId)) {
        return;
      }

      const schema = {
        "@context": "https://schema.org",
        "@type": "Service",
        "@id": "https://mingqicaiwu.com/#service",
        "name": "企业财税与工商代办服务",
        "serviceType": "财税服务、工商代办、企业服务、代理记账、社保托管、知识产权代理",
        "description": "北京名企科技有限公司是财政部批准的有代理记账许可证的财税服务平台，2017年注册，位于北京市西城区西直门外大街1号院2号楼19层C2。为企业提供注册公司、注册地址、工商代办、营业执照注册、代理记账报税、资质许可代办、工商税务变更、社保托管、商标注册、公司注销、高新申请、审计咨询、收并购企业的乱账整理等企业财税与工商服务，另外，名企科技有技术开发团队，为客户提供网站开发、系统设计、智能AI平台搭建等互联网服务。北京名企科技有限公司的客户群体覆盖小微企业和中大型企业，是综合性服务平台",
        "provider": {
          "@type": "Organization",
          "@id": "https://mingqicaiwu.com/#organization",
          "name": "北京名企科技有限公司",
          "url": "https://mingqicaiwu.com/",
          "sameAs": [
            "https://bjmqkj.com/"
          ],
          "telephone": "13910303798",
          "email": "mingqikejihr@bjmqkj.com"
        },
        "areaServed": {
          "@type": "Country",
          "name": "中国"
        },
        "url": "https://mingqicaiwu.com/",
        "offers": {
          "@type": "Offer",
          "url": "https://mingqicaiwu.com/",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "priceCurrency": "CNY",
            "description": "具体价格咨询客服13910303798"
          },
          "availability": "https://schema.org/InStock"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "注册公司、企业财税、社保公积金、工商代办与软件开发服务列表",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "注册公司、工商代办、代办执照",
                "description": "为创业者和企业提供公司注册流程咨询、材料准备、名称核准、核定经营范围及设立登记代办服务。提供免费注册公司、刻章（公章、合同章、发票章、财务章、法人章）服务"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "提供北京、上海、广州、深圳的注册地址",
                "description": "为企业提供合规注册地址服务，协助解决公司注册及经营地址需求。范围覆盖北京、上海、广州、深圳等一线城市。提供免费注册地址和0元注册服务"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "工商代办、工商变更、地址变更、法人变更、股权变更、银行变更，工商年报",
                "description": "名企科技代办企业工商登记、信息变更、备案及相关工商事务，帮助企业节省办理时间，包括工商代办、工商变更、地址变更、法人变更、股权变更、银行变更，工商年报等服务。"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "注册营业执照、注册公司、设立企业、创业服务、刻章服务",
                "description": "名企科技协助准备营业执照申请材料，注册营业执照、注册公司、设立企业、创业服务、刻章服务，代办企业设立登记及营业执照领取相关手续。"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "代理记账报税、汇算清缴、企业年报、残保金申报、企业税务服务",
                "description": "名企科技为中小企业提供日常账务处理、纳税申报、税务咨询及财务管理服务，包括代理记账报税、汇算清缴、企业年报、残保金申报、企业税务服务，为大中型企业、国有企业并购提供整理乱账的服务等。"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "代办许可、代办食品经营许可证、图书零售批发许可证、增值电信业务许可证、进出口许可证，三体系认证咨询",
                "description": "名企科技根据企业经营范围需求，协助办理相关行业经营许可证及审批事项，常见的许可证有：食品经营许可证、图书零售批发许可证、增值电信业务许可证、进出口许可证等，提供三体系认证咨询服务，来满足中小微、国央企等企业的不同需求"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "代办资质，代办ICP电信许可证、EDI许可证、演出经纪许可证、质量体系认证咨询",
                "description": "名企科技协助企业申请经营所需资质，提供材料准备、流程指导及申报代办服务，代办ICP电信许可证、EDI许可证、演出经纪许可证等，提供质量体系认证咨询等服务。"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "工商变更、变更公司地址、变更公司名称、变更法人、变更银行账户",
                "description": "名企科技为小微企业及大中型企业、国有企业、民非组织等企业机构，代办公司名称、地址、法人、股东、注册资本、经营范围等工商变更事项。"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "税务变更，税务迁址，税务登记，税务发票提额，解决税务异常",
                "description": "名企科技协助企业办理税务登记信息变更、税务备案调整、税务变更，税务迁址，税务发票提额，解决税务异常及相关税务事项。"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "社保托管、增员、减员、社保基数调整、社保扣费、工资表核算、公积金托管",
                "description": "名企科技为企业提供员工社保开户、增减员、缴纳申报、社保基数调整、社保扣费、工资表核算、公积金托管及社保事务托管服务。"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "商标注册代办，知识产权代办，软件著作权代办，创作权代办，高新申请代理",
                "description": "名企科技协助小微企业、初创企业、大中型企业、国有企业、社会团体、协会组织、民办非盈利组织，进行商标查询、申请材料准备、商标提交及注册、知识产权代办，软件著作权代办，创作权代办，高新申请代理及进度跟进服务。"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "公司注销，税务清算，公司清算，工商注销",
                "description": "名企科技为企业提供税务清算、工商注销、银行及社保账户注销等公司注销代办服务。"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "申请高新、国家高新企业申报、中关村高新申报、专精特新申报、小巨人申请",
                "description": "名企科技协助企业准备国家高新企业申报、中关村高新申报、专精特新申报、小巨人申请认定材料，提供申报规划、资料整理及流程指导，为中小企业以及国有企业、大型企业提供企业及财务服务。"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "审计咨询，招投标咨询，标书撰写，专项审计咨询，报表审计咨询",
                "description": "名企科技为企业提供财务审计、专项审计、税务审查及相关审计咨询服务，为企业的招投标提供支持。"
              }
            }
          ]
        }
      };

      const script = document.createElement('script');
      script.id = schemaId;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    },

    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768; // 根据屏幕宽度判断是否是移动端
    },
    imgLoad() {
      this.$nextTick(() => {
        const imgElement = this.$refs.imgHeight;
        if (imgElement && imgElement.height) {
          this.imgHeight = imgElement.height + 'px';
        }
      });
    },
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    updateHeight() {
      // 通过计算属性更新height
      this.$forceUpdate();
    },
    handleClick(id) {
      const contentPageUrl = this.$router.resolve({ name: 'xinwen' }).href;
      const urlWithId = `${contentPageUrl}?id=${id}`;

      // 在新标签页打开带 id 的 URL
      window.open(urlWithId, '_blank');
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.fetchNews()
    },
    fetchNews() {
      // 假设这里是你的后端接口
      fetch(`https://mingqicaiwu.com:8201/admin/news/getTitle/${this.currentPage}/5`)
        .then(response => response.json())
        .then(data => {
          this.total = data.data.total
          this.newsList = data.data.listPage.records
        })
        .catch(error => {
          alert("查询失败，请重新刷新")
          console.error("分页查询出错，原因是", error);
        })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    pathRemen() {
      this.$router.push('/remen')
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathCompanyReg() {
      this.$router.push('/zhuce')
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathxinxi() {
      this.$router.push('/xinxi')
    },
    pathcontact() {
      this.$router.push('/contact')
    },
    pathzhidu() {
      this.$router.push('/zhidu')
    },
    // 
  },
}
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
  .el-carousel__indicator--horizontal {
    display: inline-block;
    padding: 5px 4px !important;
  }

  .responsive-carousel el-carousel el-carousel--horizontal {
    width: 100%;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }

  .el-menu--horizontal>.el-menu-item {
    height: 30px !important;
    line-height: 30px !important;
  }

}
</style>


<style scoped>
/* 大轮播图样式 */
.responsive-carousel {
  width: 100%;
}

.carousel-image {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.carousel {
  margin-top: 107px;
}

/* 热门服务 */
.popularSer {
  margin-top: 4vh;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.minePopular {
  font-size: 35px;
  font-weight: 400;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.minePopular1 {
  font-size: 35px;
  font-weight: 400;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}


.serviceContainer {
  display: flex;
  margin-top: 17px;
  justify-content: center;
}

.service1 {
  width: 200px;
  height: 140px;
  background-color: #fddbdb;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  cursor: pointer;
  font-weight: 700;
}

.service1:hover {
  width: 200px;
  height: 140px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 700;
  background-color: #d22525;
  /* 悬浮时背景颜色 */
  color: #fff;
  /* 悬浮时文字颜色 */
}

.service4 {
  width: 200px;
  height: 140px;
  background-color: #fddbdb;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  cursor: pointer;
  font-weight: 700;
}

.service4:hover {
  width: 200px;
  height: 140px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 700;
  background-color: #d22525;
  /* 悬浮时背景颜色 */
  color: #fff;
  /* 悬浮时文字颜色 */
}

.service2 {
  width: 200px;
  height: 140px;
  background-color: #fddbdb;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-left: 17px;
  font-weight: 700;
  cursor: pointer;
}

.service2:hover {
  width: 200px;
  height: 140px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 700;
  background-color: #d22525;
  /* 悬浮时背景颜色 */
  color: #fff;
  /* 悬浮时文字颜色 */
}


/* 服务优势 */
.fuwuyoushi {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  margin-top: 6px;
}

.box {
  width: 370px;
  height: 225px;
  background-color: #037dfb91;
  margin-left: 6px;
  margin-top: 6px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.ziyuanheight {
  height: 80px;
}

.goodtitle {
  font-size: 30px;
  color: #fdfcb8;
  /* font-family: 'fangzheng', sans-serif; */
  font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  font-weight: 550;
  transform: scaleX(1.2) scaleY(2.5);
  line-height: 92px;
}

.goodtext {
  font-size: 23px;
  color: #fdfcb8;
  /* font-family: 'fangzheng', sans-serif; */
  font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  margin-top: 15px;
}


/* 腰线 */
.yaoxianda {
  width: 100%;
  height: 175px;
  background-color: #000;
  color: white;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  margin-top: 8vh;
  text-align: left;
}

.biaoti {
  font-weight: 700;
  font-size: 25px;
}

.quanfangwei {
  font-weight: 500;
  font-size: 20px;
  margin-top: -7px;
}

.fangxin {
  font-size: 28px;
  color: red;
}

.duigou {
  font-size: small;
}

.duigou1 {
  font-size: small;
  margin-top: 5px;
}

.duichen {
  margin-left: 45px;
}

.rexian {
  font-size: 20px;
}

.shoujihao {
  font-size: 25px;
  font-weight: 700;
}

.hongdise {
  background-color: #b30101;
  color: white;
  font-size: 25px;
  font-weight: 700;
  width: 180px;
  height: 175px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  /* font-family: 'msyhbd', sans-serif; */
}

/* 腰线1 */
.yaoxianda1 {
  width: 100%;
  height: 175px;
  background-color: #000;
  color: white;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  margin-top: 8vh;
  text-align: left;
}

.hongdise1 {
  background-color: #b30101;
  color: white;
  font-size: 25px;
  font-weight: 700;
  width: 180px;
  height: 175px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* font-family: 'msyhbd', sans-serif; */
  font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
}

.quanfangwei2 {
  font-weight: 500;
  font-size: 20px;
  margin-top: -7px;
}

.quanfangwei1 {
  font-weight: 900;
  font-size: 30px;
  margin-top: 10px;
}

.kuandu {
  height: 83px;
  display: flex;
  align-items: center;
  /* 水平居中 */
  margin-top: -6px;
}


.biaoti1 {
  font-size: 25px;
  font-weight: 900;
  transform: scaleX(1.5) scaleY(3);
  margin-left: 63px;
  color: #ff0000;
  /* font-family: 'msyhbd', sans-serif; */
  font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  width: 244px;
}

.biaoti2 {
  /* font-family: 'msyhbd', sans-serif; */
  font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  font-size: 25px;
  ;
  font-weight: 900;
  transform: scaleX(1.5) scaleY(3);
  margin-left: 60px;
  color: #ff0000;
  width: 237px;
}


/* 我们的客户 */
.juzhong {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
}

.kehu:hover .dazi,
.kehu:hover .zuoer,
.kehu:hover .youyi,
.kehu1:hover .dazi,
.kehu1:hover .zuoer,
.kehu1:hover .youyi {
  border-color: #c9c9c9;
}

/* 保持其他已有样式 */
.kehu,
.kehu1 {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.kehu1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 50px;
}

.dazi {
  height: 99px;
  width: 130px;
  border: 6px solid #d22525;
  font-size: 27px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 10px;
}

.zuoer {
  height: 72px;
  width: 130px;
  border-left: 6px solid #d22525;
  border-right: 6px solid #d22525;
  border-bottom: 6px solid #d22525;
  font-size: 18px;
  margin-top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 10px;
  flex-direction: column;
  text-align: left;
}

.youyi {
  height: 177px;
  width: 153px;
  border-top: 6px solid #d22525;
  border-right: 6px solid #d22525;
  border-bottom: 6px solid #d22525;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  flex-direction: column;
  text-align: left;
}


.fangkuai {
  list-style-type: square;
  margin-top: 0px;
  padding-left: 10px;
}

.yuanquan {
  list-style-type: circle;
}

ul,
li {
  margin: 0;
  padding: 0;
}

/* 成功案例 */

.carouselcard {
  margin-top: 6px;
}

.succ {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #535353;
}

.succ1 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  color: #535353;
}

.carousel-imagecard {
  width: 175px;
  height: 220px;
  object-fit: fill;
  margin-left: 5px;
  display: block;
}

.text {
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 14.5px;
}

.text1 {
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 14.5px;
}

.text4 {
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 14.5px;
}

.text3 {
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 14.5px;
}

.text2 {
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 13px;
  line-height: 21px;
}

/* AI友好的FAQ区块样式 */
.ai-faq-section {
  background: linear-gradient(135deg, #faf8f8 0%, #f5f0f0 100%);
  padding: 30px 20px;
}

.faq-container {
  max-width: 1000px;
  margin: 0 auto;
  text-align: left;
}

.faq-item {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 15px;
  box-shadow: 0 2px 8px rgba(210, 37, 37, 0.1);
  overflow: hidden;
}

.faq-question {
  padding: 18px 20px;
  font-size: 17px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  background: #fff;
  border-bottom: 1px solid #f0e6e6;
  list-style: none;
  position: relative;
}

.faq-question::-webkit-details-marker {
  display: none;
}

.faq-question::after {
  content: '+';
  position: absolute;
  right: 20px;
  font-size: 24px;
  color: #d22525;
  transition: transform 0.3s;
}

.faq-item[open] .faq-question::after {
  content: '−';
}

.faq-answer {
  padding: 0 20px;
  background: #fdfbfb;
}

.faq-answer p {
  margin-bottom: 12px;
  line-height: 1.8;
  color: #555;
  font-size: 15px;
}

.faq-answer ul {
  margin: 10px 0 15px 20px;
  padding-left: 10px;
}

.faq-answer li {
  margin-bottom: 8px;
  line-height: 1.7;
  color: #555;
}

.faq-answer strong {
  color: #d22525;
}

.faq-answer a {
  color: #d22525;
  text-decoration: none;
  border-bottom: 1px dotted #d22525;
}

.faq-answer a:hover {
  border-bottom: 1px solid #d22525;
}

@media (max-width: 768px) {
  .faq-question {
    font-size: 15px;
    padding: 15px;
    padding-right: 40px;
  }

  .faq-answer {
    padding: 15px;
  }

  .faq-answer p {
    font-size: 14px;
  }
}

/* 企业权威性引用区块 */
.company-quote {
  max-width: 900px;
  margin: 40px auto;
  padding: 30px 40px;
  background: linear-gradient(135deg, #fdf8f8 0%, #f8f0f0 100%);
  border-left: 5px solid #d22525;
  border-radius: 0 10px 10px 0;
  box-shadow: 0 4px 15px rgba(210, 37, 37, 0.1);
  font-style: italic;
  color: #555;
  position: relative;
}

.company-quote::before {
  content: '"';
  position: absolute;
  top: 10px;
  left: 15px;
  font-size: 60px;
  color: #d22525;
  opacity: 0.3;
  font-family: Georgia, serif;
}

.company-quote p {
  font-size: 16px;
  line-height: 1.9;
  margin-bottom: 15px;
  padding-left: 20px;
  color: #444;
}

.company-quote strong {
  color: #d22525;
  font-weight: 600;
}

.company-quote a {
  color: #d22525;
  text-decoration: none;
  border-bottom: 1px dotted #d22525;
}

.company-quote footer {
  text-align: right;
  font-size: 14px;
  color: #888;
  margin-top: 15px;
  font-style: normal;
}

.company-quote cite {
  color: #d22525;
  font-weight: 500;
}

@media (max-width: 768px) {
  .company-quote {
    margin: 30px 15px;
    padding: 20px 25px;
  }

  .company-quote::before {
    font-size: 40px;
    top: 5px;
    left: 10px;
  }

  .company-quote p {
    font-size: 14px;
    padding-left: 10px;
  }
}

/* 服务流程区块样式 */
.service-process-section {
  background: linear-gradient(135deg, #fff 0%, #faf8f8 100%);
  padding: 40px 20px;
  margin-top: 0%;
}

.process-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 900px;
  margin: 30px auto;
  gap: 20px;
}

/* 每一行 */
.process-row {
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

/* 第一行3个步骤 */
.row-3 .process-step {
  flex: 0 0 calc(33.333% - 40px);
  max-width: 240px;
}

/* 第二行2个步骤 */
.row-2 .process-step {
  flex: 0 0 calc(40% - 30px);
  max-width: 300px;
}

.process-step {
  background: #fff;
  border-radius: 12px;
  padding: 25px 15px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(210, 37, 37, 0.1);
  border: 2px solid #f5e6e6;
  transition: all 0.3s ease;
  position: relative;
}

.process-step:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(210, 37, 37, 0.2);
  border-color: #d22525;
}

.step-number {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #d22525 0%, #ff6b6b 100%);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  margin: 0 auto 15px;
  box-shadow: 0 4px 10px rgba(210, 37, 37, 0.3);
}

.step-content h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
}

.step-content p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.step-content .highlight {
  color: #d22525;
  font-weight: 600;
}


.process-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #d22525;
  font-weight: 700;
  padding: 0 5px;
}

/* 行与行之间的连接 */
.row-connector {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 20px;
  position: relative;
}

.connector-line {
  width: 2px;
  flex: 1;
  background: linear-gradient(to bottom, #d22525, #ff9999);
}

.connector-arrow {
  font-size: 20px;
  color: #d22525;
  font-weight: 700;
  line-height: 1;
}

/* 服务对比表格 */
.service-comparison {
  max-width: 1080px;
  margin: 40px auto 0;
  padding: 32px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.service-comparison h3 {
  text-align: center;
  font-size: 22px;
  color: #333;
  margin-bottom: 28px;
}

.service-comparison h3 .vs-text {
  font-size: 35px;
  color: #d22525;
  font-weight: 700;
  margin: 0 6px;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
}

.comparison-table th,
.comparison-table td {
  padding: 16px 18px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}

.comparison-table th {
  background: #fdf8f8;
  font-weight: 700;
  color: #333;
  white-space: nowrap;
  font-size: 15px;
}

.comparison-table td {
  color: #444;
  line-height: 1.6;
  font-size: 14px;
  transition: background 0.2s ease;
}

.comparison-table tbody tr:hover td {
  background: #fafafa;
}

.comparison-table tbody tr:last-child td {
  border-bottom: none;
}

.col-item {
  width: 11%;
  white-space: nowrap;
}

.col-item strong {
  display: flex;
  align-items: center;
  gap: 6px;
}

.col-item strong i {
  font-size: 18px;
  color: #d22525;

}

.col-mq {
  width: 34%;
}

.col-other {
  width: 27.5%;
}

.comparison-table .highlight-col {
  background: linear-gradient(135deg, #fff5f5 0%, #fff 100%);
  color: #d22525;
  font-weight: 600;
  position: relative;
}

.comparison-table thead .highlight-col {
  background: linear-gradient(135deg, #fef0f0 0%, #fdf8f8 100%);
}

.comparison-table .highlight-col time,
.comparison-table .highlight-col data {
  color: #d22525;
  font-weight: 700;
}

@media (max-width: 768px) {
  .process-container {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .process-row {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .row-3 .process-step,
  .row-2 .process-step {
    flex: 0 0 auto;
    min-width: 280px;
    max-width: 320px;
    width: 100%;
  }

  .process-arrow {
    transform: rotate(90deg);
    padding: 5px 0;
  }

  .row-connector {
    flex-direction: row;
    height: auto;
    width: 30px;
  }

  .connector-line {
    width: auto;
    height: 2px;
    background: linear-gradient(to right, #d22525, #ff9999);
  }

  .connector-arrow {
    transform: rotate(-90deg);
  }

  .service-comparison {
    padding: 20px 16px;
    margin: 24px 12px 0;
    border-radius: 14px;
  }

  .service-comparison h3 {
    font-size: 18px !important;
    margin-bottom: 18px;
  }

  .service-comparison h3 .vs-text {
    font-size: 22px;
  }

  .comparison-cards {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .comparison-card {
    background: #fff;
    border-radius: 12px;
    border: none;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .comparison-card:active {
    transform: scale(0.98);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  }

  .card-title {
    background: linear-gradient(135deg, #fef0f0 0%, #fdf8f8 100%);
    padding: 12px 16px;
    font-weight: 700;
    font-size: 16px;
    color: #333;
    border-bottom: 1px solid #f5f5f5;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .card-title::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 16px;
    background: #d22525;
    border-radius: 2px;
    flex-shrink: 0;
  }

  .card-columns {
    display: flex;
    flex-direction: column;
  }

  .card-col {
    padding: 12px 16px;
    border-bottom: 1px solid #f8f8f8;
  }

  .card-col:last-child {
    border-bottom: none;
    padding-bottom: 14px;
  }

  .card-label {
    font-size: 16px;
    margin-bottom: 6px;
    font-weight: 500;
  }

  .card-value {
    font-size: 14px;
    color: #555;
    line-height: 1.7;
    text-align: left;
  }

  .card-value.mq {
    color: #d22525;
    font-weight: 600;
    line-height: 1.7;
  }

  .card-col-mq {
    background: linear-gradient(135deg, #fff8f8 0%, #fff 100%);
    padding-left: 16px;
    border-left: 3px solid #d22525;
  }
}

/* 客户的肯定 */
.kehudegood {
  height: 220px;
  width: 190px;
  margin-left: 5px;
}


/* 新闻 */
.newInfo {
  background-image: url(../assets/img/newInfo.jpg);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 1550px 400px;
}

.index_ans01 {
  width: 690px;
  margin: 0 auto;
  height: 400px;
}

.index_ans02 {
  text-align: center;
  padding-top: 1px;
}

.gengduo {
  text-align: right;
  margin-top: 15px;
  cursor: pointer;
}

.look {
  display: block;
  width: 65px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  background: #d42828;
  color: #fff;
  font-size: 14px;
  border-radius: 12px;
  cursor: pointer;
}

.yema {
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
}

.tableCSS {
  width: 690px;
  overflow: hidden;
  /* height: 207px; */
  margin-top: 10px;
  border: 1px solid #ddd;
  border-collapse: collapse;
}

.tdCSS1 {
  width: 84px;
  padding: 8px;
  text-align: center;
  border: none;
  font-size: 19px;
  color: #d22525;
  font-weight: 700;
}

.tdCSS {
  padding: 8px;
  text-align: left;
  border: none;
  font-size: 15px;
}

/* 其他 */
h1 {
  font-size: 0%;
}


@media (max-width: 768px) {

  /* 轮播图 */
  .carousel {
    /* height: auto; */
    margin-top: 90px !important;
    width: 100% !important;
  }

  .el-carousel__item {
    width: 100vw;
    height: auto;
    object-fit: contain;
    display: block;
  }

  .carousel-image {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
  }


  /* 热门服务 */
  .popularSer {
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .minePopular {
    font-size: 18px !important;
    font-weight: 700;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    margin-top: 5px;
  }

  .minePopular1 {
    transform: scaleX(1);
    font-size: 18px !important;
    font-weight: 400;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }

  .serviceContainer {
    margin-top: 5px;
  }

  .service1 {
    width: 80px !important;
    height: 65px !important;
    background-color: #fddbdb;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px !important;
    cursor: pointer;
  }

  .service1:hover {
    width: 80px !important;
    height: 65px !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px !important;
    cursor: pointer;
    background-color: #d22525;
    /* 悬浮时背景颜色 */
    color: #fff;
    /* 悬浮时文字颜色 */
  }

  .service4 {
    width: 80px !important;
    height: 65px !important;
    background-color: #fddbdb;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px !important;
    cursor: pointer;
    font-weight: 700;
  }

  .service4:hover {
    width: 80px !important;
    height: 65px !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px !important;
    cursor: pointer;
    background-color: #d22525;
    /* 悬浮时背景颜色 */
    color: #fff;
    /* 悬浮时文字颜色 */
    font-weight: 700;
  }

  .service2 {
    width: 80px !important;
    height: 65px !important;
    background-color: #fddbdb;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px !important;
    margin-left: 6px;
    cursor: pointer;
  }

  .service2:hover {
    width: 80px !important;
    height: 65px !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px !important;
    margin-left: 6px;
    cursor: pointer;
    background-color: #d22525;
    /* 悬浮时背景颜色 */
    color: #fff;
    /* 悬浮时文字颜色 */
  }

  .service3 {
    width: 80px !important;
    height: 65px !important;
    background-color: #fddbdb;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px !important;
    margin-left: 6px;
    font-weight: 700;
    cursor: pointer;
  }

  .service3:hover {
    width: 80px !important;
    height: 65px !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px !important;
    margin-left: 6px;
    cursor: pointer;
    font-weight: 700;
    background-color: #d22525;
    /* 悬浮时背景颜色 */
    color: #fff;
    /* 悬浮时文字颜色 */
  }


  /* 服务优势 */
  .fuwuyoushi {
    margin-top: 5px;
  }

  .box {
    width: 185px;
    height: 107px;
    background-color: #9bcdff;
    justify-content: center;
    align-items: center;
    margin-left: 2px;
    margin-top: 2px;
    border-radius: 4px;
  }

  .ziyuanheight {
    height: 35px;
  }

  .goodtitle {
    font-size: 15px;
    transform: scaleX(1.3) scaleY(1.7);
    color: #fdfcb8;
    font-weight: 550;
    line-height: 32px;
    font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  }

  .goodtext {
    font-size: 13px;
    margin-top: 8px;
  }

  /* 腰线 */
  .yaoxianda {
    width: 100%;
    height: 90px;
    background-color: #000;
    color: white;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 0px;
    margin-top: 2vh;
    text-align: left;
  }

  .biaoti {
    font-weight: 700;
    font-size: 16px;
    margin-top: -5px;
    line-height: 29px;
  }

  .quanfangwei {
    font-weight: 500;
    font-size: 9px;
    margin-top: -3px;
  }

  .fangxin {
    font-size: 11px;
    color: red;
    font-weight: 700;
  }

  .duigou {
    font-size: 9px;
  }

  .duigou1 {
    font-size: 9px;
    margin-top: 4px;
  }

  .duichen {
    margin-left: 22px;
  }

  .rexian {
    font-size: 7px;
  }

  .shoujihao {
    font-size: 9px;
  }

  .hongdise {
    background-color: #b30101;
    color: white;
    font-size: 11px;
    font-weight: 700;
    width: 95px;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }


  /* 腰线1 */

  .yaoxianda1 {
    width: 100%;
    height: 86px;
    background-color: #000;
    color: white;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 0px;
    margin-top: 2vh;
    text-align: left;
  }

  .hongdise1 {
    background-color: #b30101;
    color: white;
    font-size: 13px;
    font-weight: 700;
    width: 82px;
    height: 86px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }


  .quanfangwei2 {
    font-weight: 500;
    font-size: 13px;
    margin-top: 0px;
  }

  .quanfangwei1 {
    font-weight: 900;
    font-size: 14px;
    margin-top: 0px;
  }

  .kuandu {
    width: auto;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    text-align: left;
    height: 56px;
    margin-top: 0px;
  }

  .biaoti1 {
    font-size: 13px;
    font-weight: 550;
    transform: scaleX(1.3) scaleY(1.8);
    line-height: 28px;
    margin-left: 0px;
    width: 122px;
  }

  .biaoti2 {
    font-size: 13px;
    font-weight: 550;
    transform: scaleX(1.3) scaleY(1.8);
    line-height: 28px;
    margin-left: 0px;
    width: 122px;
  }


  /* 我们的客户 */
  .juzhong {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 5px;
  }

  .kehu {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .kehu1 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0px;
    margin-top: 8px;
  }

  .dazi {
    height: 43px;
    width: 120px;
    border: 1px solid black;
    font-size: 18px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 10px;
  }

  .zuoer {
    height: 58px;
    width: 120px;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    font-size: 14px;
    margin-top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-left-radius: 10px;
    flex-direction: column;
    text-align: left;
  }

  .fangkuai {
    list-style-type: square;
    margin-top: 0px;
    padding-left: 10px;
  }

  .youyi {
    height: 102px;
    width: 160px;
    border-top: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    flex-direction: column;
    text-align: left;
  }

  .yuanquan {
    list-style-type: circle;
  }


  /* 成功案例 */
  .carouselcard {
    margin-top: 5px;
  }

  .succ {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #535353;
    gap: 4px;
  }

  .succ1 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5px;
    color: #535353;
    gap: 4px;
  }

  .success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-left: 0px;
    width: 92px;
  }

  .success1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 92px;
  }

  .carousel-imagecard {
    height: 99px;
    width: 81px;
    object-fit: fill;
    margin-left: 0px;
    display: block;
  }

  .text {
    font-size: 12px;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 0px;
    height: 14px;
    margin-top: 0px;
  }

  .text1 {
    font-size: 12px;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 0px;
    height: 14px;
    margin-top: 0px;
  }

  .text2 {
    font-size: 9px;
    height: 50px;
    margin-bottom: 2px;
    /* width:70px; */
    font-weight: 700;
    margin-top: 5px;
    line-height: normal;
  }

  .text4 {
    font-weight: 700;
    margin-top: 2px;
    margin-bottom: 2px;
    font-size: 12px;
    height: 33px;
  }

  .text3 {
    font-weight: 700;
    margin-top: 2px;
    margin-bottom: 2px;
    font-size: 12px;
    height: 33px;
  }


  /* 客户的肯定 */
  .kehudegood {
    height: 11vh;
    width: 7vh;
    margin-left: 10px;
  }


  /* 新闻 */
  .newInfo {
    background-image: url(../assets/img/newInfo.jpg);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 139% 250px;
  }

  .index_ans01 {
    width: 100%;
    margin: 0 auto;
    height: 250px;
  }

  .index_ans02 {
    text-align: center;
    font-size: 12px;
    color: #333;
    /* padding-top: 20px; */
    height: 250px;
  }

  .gengduo {
    margin-top: 7px;
    width: 90%;
  }

  .look {
    display: block;
    width: 29px;
    height: 17px;
    line-height: 17px;
    text-align: center;
    background: #d42828;
    color: #fff;
    font-size: 8px;
    border-radius: 4px;
  }

  .yema {
    margin-top: -2px;
    margin-left: auto;
    margin-right: auto;
  }

  .tableCSS {
    width: 70%;
    overflow: hidden;
    height: auto;
    margin-top: 3px;
    border: 1px solid #ddd;
    border-collapse: collapse;
    font-size: 8px;
    margin-left: 15%;
  }

  .tdCSS1 {
    width: 32px;
    padding: 3px;
    text-align: left;
    border: none;
    font-size: 10px;
  }

  .tdCSS {
    padding: 3px;
    text-align: left;
    border: none;
    font-size: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue